export default __webpack_public_path__ + "static/media/eye-closed.53187a18.svg";